<template>
  <div class="inline-block">
    <el-checkbox
      class="check-all"
      v-model="checkAll"
      :indeterminate="isIndeterminate"
      @input="handleCheckAllInput"
      @change="handleCheckAllChange"
      >全选</el-checkbox
    >
    <el-checkbox-group
      size="small"
      class="inline-block"
      :value="value"
      @input="handleInput"
      @change="handleChange"
      v-bind="attrs"
      v-on="listeners"
    >
      <el-checkbox
        v-for="item in innerList"
        :key="item.value"
        :label="item.value"
        >{{ item.label }}</el-checkbox
      >;
    </el-checkbox-group>
  </div>
</template>


<script>
import enumMixin from "../mixin/enum.js";

export default {
  name: "XxCheckBoxGroup",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    useList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: this.list,
      checkAll: false,
      isIndeterminate: false,
    };
  },
  computed: {
    attrs() {
      let { ...attrs } = this.$attrs;
      const defaultAttrs = {
        size: "small",
      };
      return {
        ...defaultAttrs,
        ...attrs,
      };
    },
    listeners() {
      let { change, input, ...listeners } = this.$listeners;
      return listeners;
    },
    innerList() {
      return this.useList ? this.list : this.getData;
    },
  },
  watch: {
    list: {
      handler() {
        this.handleChange(this.value);
      },
    },
    allEnumListMap: {
      handler() {
        this.handleChange(this.value);
      },
    },
  },
  methods: {
    handleInput(v) {
      this.$emit("input", v);
    },
    handleChange(v) {
      const checkedCount = v.length;
      this.checkAll = checkedCount === this.innerList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.innerList.length;
      this.$emit("change", v);
    },
    handleCheckAllInput(v) {
      const newValue = v ? this.innerList.map((item) => item.value / 1) : [];
      this.$emit("input", newValue);
    },
    handleCheckAllChange(v) {
      const newValue = v ? this.innerList.map((item) => item.value / 1) : [];
      this.isIndeterminate = false;
      this.$emit("change", newValue);
    },
  },
  mixins: [enumMixin],
};
</script>

<style lang="scss" scoped>
.check-all {
  margin-right: 8px;
}
.el-checkbox + .el-checkbox {
  margin-left: 16px;
}
</style>
